import Phaser from "phaser";
import GameScene from "./gameScene";
import { getGameAssets } from "./gameSrc";
import "phaser/plugins/spine/dist/SpinePlugin.js";

export default class GameManager {
  constructor(data = {}) {
    this.eventBus = data.EventBus;
    const { w, h, parent, eventBus, skipLoading, isMuted } = data;
    const levelTime = 10; // 单位是s
    // 创建场景，使用资源注入
    const assets = getGameAssets();
    const gameSceneInstance = new GameScene(
      assets,
      eventBus,
      levelTime,
      skipLoading,
      isMuted
    );
    const config = {
      type: Phaser.AUTO,
      parent: parent,
      width: w,
      height: h,
      scene: [gameSceneInstance],
      plugins: {
        scene: [
          { key: "SpinePlugin", plugin: window.SpinePlugin, mapping: "spine" },
        ],
      },
      scale: {
        mode: Phaser.Scale.ENVELOP,
        autoCenter: Phaser.Scale.CENTER_BOTH,
      }
    };
    this._game = new Phaser.Game(config);
    return this._game;
  }
}
